import { createFeatureSelector } from '@ngrx/store';
import { StepperDataState } from './stepper.reducer';

export const stepperDataState = createFeatureSelector<StepperDataState>('stepper');
